import { render, staticRenderFns } from "./CommissionHistory.vue?vue&type=template&id=f3fe24b2&scoped=true"
import script from "./CommissionHistory.vue?vue&type=script&lang=js"
export * from "./CommissionHistory.vue?vue&type=script&lang=js"
import style0 from "./CommissionHistory.vue?vue&type=style&index=0&id=f3fe24b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fe24b2",
  null
  
)

export default component.exports